document.addEventListener("DOMContentLoaded", () => {
  const disclaimer = document.querySelectorAll('[data-spam-detection-disclaimer] a');
  if (disclaimer) {
    disclaimer.forEach(a => {
      a.setAttribute('rel', 'nofollow');
    });
  }
  const judgeReview = localStorage.getItem("judgeReview");
  if(!judgeReview) {
    const scoreEle = document.querySelector('.jdgm-carousel-wrapper .jdgm-all-reviews-rating');
    const numberReviewsEle = document.querySelector('.jdgm-carousel-wrapper .jdgm-carousel-number-of-reviews');
    if(scoreEle && numberReviewsEle) {
      localStorage.setItem("judgeReview", JSON.stringify({
        score: scoreEle.dataset.score,
        numberReviews: numberReviewsEle.dataset.numberOfReviews
      }))
    }
  }
});